
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ExpansionPanels',

  props: {
    eager: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Array,
      default: () => [],
    },
    openPanel: {
      type: Number,
      default: -1,
    },
    mustardBackgroundColor: {
      type: Boolean,
      default: false,
    },
    hasCaretIcon: {
      type: Boolean,
      default: false,
    },
    allOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openPanels: [],
    };
  },
  fetch() {
    this.openPanels = this.handleAllOpen();
  },
  computed: {
    contentLength() {
      return this.content.length;
    },
  },
  methods: {
    resetHash() {
      window.location.hash = '';
    },
    handleAllOpen() {
      if (this.allOpen) {
        // @ts-ignore
        return this.content.map((_e, i) => i);
      } else {
        // @ts-ignore
        return this.openPanel !== -1 ? [this.openPanel] : [];
      }
    },
  },
});
